import React from 'react';
import { FaTrashAlt } from 'react-icons/fa';
import './DeleteAccount.css';

const DeleteAccount = () => {
    return (
        <div className="delete-account-container fade-in">
            <div className="delete-account-card">
                <header className="delete-header">
                    <div className="trash-icon-circle">
                        <FaTrashAlt />
                    </div>
                    <h1>Account Deletion Notice</h1>
                    <p className="subtitle">Please read the following information carefully before proceeding with account deletion.</p>
                </header>

                <div className="steps-section">
                    <h2>How to Delete Your Account (Mobile App)</h2>
                    <div className="steps-container">
                        <div className="step-card">
                            <span className="step-num">1</span>
                            <p><strong>Go to Profile:</strong> Open the app and tap the <strong>Profile Icon</strong> at the bottom right.</p>
                        </div>
                        <div className="step-card">
                            <span className="step-num">2</span>
                            <p><strong>Scroll Down:</strong> On your profile screen, scroll down to the very bottom.</p>
                        </div>
                        <div className="step-card">
                            <span className="step-num">3</span>
                            <p><strong>Find Danger Zone:</strong> Locate the section titled <strong>"Danger Zone"</strong>.</p>
                        </div>
                        <div className="step-card">
                            <span className="step-num">4</span>
                            <p><strong>Click Delete Profile:</strong> Tap the red <strong>"Delete Profile"</strong> button.</p>
                        </div>
                        <div className="step-card">
                            <span className="step-num">5</span>
                            <p><strong>Confirmation:</strong> Confirm your decision when the alert message appears.</p>
                        </div>
                        <div className="step-card">
                            <span className="step-num">6</span>
                            <p><strong>Final Step:</strong> Tap <strong>"Delete Everything"</strong> to permanently remove your account.</p>
                        </div>
                    </div>
                    <p className="step-note"><strong>Note:</strong> Once finished, you will be logged out and your data will be erased forever.</p>
                </div>

                <div className="action-buttons">
                    <p className="app-instruction">To delete your account, please perform this action from within the mobile app settings.</p>
                </div>
            </div>
        </div>
    );
};

export default DeleteAccount;
